import { GridColumnType } from "../../../components/FinalMolGrid/libs/data/gridColumnType";

export const ViewResourcesListData = {
  columns: [
   
    {
      name: "Resources Name",
      fieldName: "resourceName",
      allowShort: false,
      colType: GridColumnType.Text,

      // colStyle: {
      //     width: "15%",
      //     textAlign: "center",
      //     color: "color",
      //     backgroundColor: "white"
      // }
    },
    {
      name: "Type",
      fieldName: "resourceTypeName",
      allowShort: false,
      colType: GridColumnType.Text,

      // colStyle: {
      //     width: "15%",
      //     textAlign: "center",
      //     color: "color",
      //     backgroundColor: "white"
      // }
    },
    {
      name: "Publish Date",
      fieldName: "publishDate",
      allowShort: false,
      colType: GridColumnType.DATE,
      colSettings: {
        format: "DD-MMM-YYYY",
      },
      // colStyle: {
      //     width: "15%",
      //     textAlign: "center",
      //     color: "color",
      //     backgroundColor: "white"
      // },
    },

    {
      name: "Visibility",
      fieldName: "visibilityStatus",
      colType: GridColumnType.Text,
      allowShort: false,
      // colStyle: {
      //     width: "15%",
      //     textAlign: "center",
      //     color: "color",
      //     backgroundColor: "white"
      // }
    },
    {
      name: "Status",
      fieldName: "statusName",
      allowShort: false,
      // colStyle: {
      //     width: "15%",
      //     textAlign: "center",
      //     color: "color",
      //     backgroundColor: "white"
      // }
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      customWrapper: [
        {
          name: "WRAPPEREDIT",
          label: "View / Edit",
        },
        {
          name: "POSTAPPROVAL",
          label: "Post Approval",
        },
      ],
      defaultAction: {
        allowEdit: false,
        allowDelete: true,
      },
      allowShort: false,
    },
  ],
  allowEdit: false,
  isRowSelectable: true,
  hasChildGridTable: false,
  gridStyle: {
    tableClass: "border-table-simple",
  },
};
